import { render, staticRenderFns } from "./Slido.vue?vue&type=template&id=cf0d2b4a&scoped=true&"
import script from "./Slido.vue?vue&type=script&lang=js&"
export * from "./Slido.vue?vue&type=script&lang=js&"
import style0 from "./Slido.vue?vue&type=style&index=0&id=cf0d2b4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0d2b4a",
  null
  
)

export default component.exports